import { Box, Typography } from '@evaneos/b2b-ui';
import PersonIcon from '@evaneos/b2b-ui/icons/PersonOutline';
import { useIntl } from 'react-intl';

import { Avatar } from '../../../../resources/agent/components/Avatar';
import { Agent } from '../../../../resources/agent/types';
import { DefinitionList } from '../../../../design-system/DefinitionList/DefinitionList';
import { useDossierLayoutInfo } from '../../DossierLayoutInfoContext';

import { AgentSelectForm } from './AgentSelectForm';

type AgentInfoProps = {
    assignedAgent: Agent | undefined;
    dossierId: string;
};

export function AgentInfo({ assignedAgent, dossierId }: Readonly<AgentInfoProps>) {
    const { formatMessage } = useIntl();
    const dossierAgentLabelId = 'dossier-agent';
    const { isFirstColumnNarrow } = useDossierLayoutInfo();

    return (
        <DefinitionList.Item>
            <DefinitionList.Label
                id={dossierAgentLabelId}
                icon={<PersonIcon fontSize="small" aria-hidden="true" />}
                iconOnly={isFirstColumnNarrow}
            >
                {formatMessage({ id: 'dossier.followed_by' })}
            </DefinitionList.Label>
            <DefinitionList.EditableValue
                labelId={dossierAgentLabelId}
                editor={({ close }) => (
                    <AgentSelectForm
                        labelId={dossierAgentLabelId}
                        dossierId={dossierId}
                        onClose={close}
                    />
                )}
                placement="over"
                popoverWidth="trigger"
            >
                {assignedAgent && (
                    <Box display="flex" component="span" alignItems="center" gap={1}>
                        <Avatar
                            name={assignedAgent.name}
                            photoUrl={assignedAgent.photoUrl}
                            component="span"
                            aria-hidden="true"
                            sx={{
                                fontSize: '0.8rem',
                                height: 16,
                                width: 16,
                                minHeight: 16,
                                minWidth: 16,
                            }}
                        />
                        <Typography variant="body2" component="span">
                            {assignedAgent.name}
                        </Typography>
                    </Box>
                )}
            </DefinitionList.EditableValue>
        </DefinitionList.Item>
    );
}
